import useSWR from "swr";
import axios from "axios";

function useDocuments({ shouldFetch = true, labourerId, page, perPage }) {
  return useSWR(
    shouldFetch ? [`${process.env.REACT_APP_API_URL}/documents`, labourerId, page, perPage] : null,
    async ([url, labourerId, page, perPage]) => {
      const params = new URLSearchParams();

      if (labourerId) params.append('labourerId', labourerId);
      if (page) params.append('page', page);
      if (perPage) params.append('perPage', perPage);

      const { data: { documents, count } } = await axios.get(`${url}?${params.toString()}`);

      return { documents, count };
    });
}

export default useDocuments;
